module.exports = __webpack_public_path__ + "img/onion-rings-1.26617dbe.jpg";